"use client";

import { useSearchParams } from "next/navigation";
import { Suspense } from "react";

type Props = {
  delParamName?: string | string[];
  paramName: string;
  param: string | null;
  children?: React.ReactNode;
};

function TabSet({ delParamName, paramName, param, children }: Props) {
  const searchParams = useSearchParams();
  const paramVal = searchParams.get(paramName);
  const handle = () => {
    const params = new URLSearchParams(searchParams.toString());
    param ? params.set(paramName, param) : params.delete(paramName);
    if (delParamName) {
      typeof delParamName === "string" ? params.delete(delParamName) : delParamName.forEach((f) => params.delete(f));
    }
    window.history.replaceState(null, "", "?" + params.toString());
  };
  return (
    <div role="tab" className={`tab ${param === paramVal && "tab-active"}`} onClick={handle}>
      {children}
    </div>
  );
}

export function TabSetSearchParam(props: Props) {
  return (
    <Suspense
      fallback={
        <div role="tab" className="tab">
          {props.children}
        </div>
      }
    >
      <TabSet {...props} />
    </Suspense>
  );
}
